<template>
    <div class="elasticsearchWarningSearch">
        <Row :gutter="4">
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="alertRuleSearchKey" :placeholder="$t('alarms.common.filterByAlertRuleName')" @on-search="searchAlertRule()"/>
            </Col>
        </Row>
    </div>
</template>
<script>
    import TableElasticsearchWarning from '../es/TableElasticsearchWarning'
    var tableElasticsearchWarning = TableElasticsearchWarning;
    export default {
        name: 'ElasticsearchWarningSearch',
        data () {
            return {
                alertRuleSearchKey:'',
                alertRuleSearchName:''
            }
        },
        methods: {
            // 按规则名称搜索
            searchAlertRule: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('alertRuleSearchName', this.alertRuleSearchKey);
                tableElasticsearchWarning.methods.showAll();
            }
        }
    }
</script>
<style scoped>
    .elasticsearchWarningSearch
    {
        height: 51px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/es/ElasticsearchWarningSearch.vue